/**
 * ## Init Startup extras for development
 *
 * @module src/controllers/init
 */

"use strict";

const conf = require("../../config");
const func = require("../../controllers/func");

let kd;
let location;

/**
 */
const init = (kdObj) => {
  kd = kdObj;
  location = kd.doc("location")[0];
  if (location.hasOwnProperty("ui")) {
    conf.vars.ui = location.ui;
  } else {
    conf.vars.ui = "standard";
  }
};

const getCurrentWait = (waitSize, preference) => {
  const sizeIndex = Math.ceil(waitSize / 2) - 1;
  location = kd.doc("location")[0];
  if (location) {
    let thiswait =
      Math.floor(
        (func.getWaitTime(preference) +
          location.turnTimes[sizeIndex].turnTime) /
          5
      ) * 5;
    if (thiswait < 2) {
      thiswait = 2;
    }
    return thiswait;
  }
  return 0;
};

module.exports = {
  init,
  location,
  getCurrentWait,
};



/** WEBPACK FOOTER **
 ** ./src/controllers/location/index.js
 **/